import { render, staticRenderFns } from "./EntityIdentityUpdate.vue?vue&type=template&id=109c2572"
import script from "./EntityIdentityUpdate.vue?vue&type=script&lang=js"
export * from "./EntityIdentityUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports